import Button from '@/common/components/Button'
import Table from '@/common/components/Table'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { cn } from '@/common/utils/cn'
import useBillingBill from '@/features/billingBills/hooks/useBillingBill'
import { useBillingBillPaymentAdvances } from '@/features/billingBills/hooks/useBillingBillPaymentAdvances'
import { defaultColumns } from '@/features/paymentAdvances/constants/columns'
import { PaymentAdvancesTransformer } from '@/features/paymentAdvances/services/paymentAdvancesTransformer'
import { PaymentAdvanceData, PaymentAdvanceTableItem } from '@/features/paymentAdvances/types/paymentAdvance.type'
import { Link, useParams } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'

const PaymentAdvancesTab = () => {
  const { id } = useParams()

  const { filterParams, setFilterParams } = useFilterParams()

  const { data: bill } = useBillingBill({ id })

  const {
    data: paymentAdvances,
    meta,
    isPending: paymentAdvancesIsPending,
  } = useBillingBillPaymentAdvances({
    filters: {
      id,
      page: Number(filterParams.page) || 1,
    },
    mapper: Mapper.mapWithTransformer<PaymentAdvanceData[], PaymentAdvanceTableItem[]>({
      transformer: PaymentAdvancesTransformer.tableTransformer(),
    }),
  })

  const showPaymentAdvanceButton = (bill?.status === 'in_process'|| bill?.status === 'pending_payment' || bill?.status === 'partially_paid') && bill?.kind === 'payment'
  const hasPendingPaymentAdvance = paymentAdvances?.some((advance) => advance.status === 'Pendente')

  return (
    <div className="flex flex-col gap-6">
      {showPaymentAdvanceButton && (
        <>
          <Link
            to={(hasPendingPaymentAdvance || !bill?.can_create_payment_advance) ? '' : `/payment-advances/${bill?.id}/create`}
            className={cn('self-end')}
            data-tooltip-id={!bill?.can_create_payment_advance ? 'tooltip-advance-disabled' : undefined}
          >
            <Button
              type="button"
              disabled={hasPendingPaymentAdvance || !bill?.can_create_payment_advance}
              data-testid="advance_payment_button"
            >
              Antecipar pagamento
            </Button>
          </Link>

          <Tooltip id="tooltip-advance-disabled" content="Não é possível solicitar adiantamento de faturas vencidas" place="top" />
        </>
      )}

      <Table
        className={cn('max-h-[calc(100vh-192px)]', showPaymentAdvanceButton && 'max-h-[calc(100vh-256px)]')}
        rows={paymentAdvances || []}
        columns={defaultColumns}
        isLoadingData={paymentAdvancesIsPending}
        page={meta.current_page}
        totalPages={meta.total_pages}
        totalCount={meta.total}
        hasPagination
        setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        rowEmptyValue="--"
      />
    </div>
  )
}

export default PaymentAdvancesTab
